export default "__VITE_ASSET__Cta96uUm__"